export const occurrenceKey = (value) => new Date(value).getTime();

export const isRecurringEvent = (event) => {
  const raw = event?.rrule?.origOptions || event?.rrule?.options || event?.rrule;
  return Boolean(raw && typeof raw === "object" && raw.freq !== undefined && raw.freq !== null);
};

const buildAcceptedMap = (applications = []) => {
  const map = new Map();
  for (const app of applications) {
    if (app.status !== "accepted" || !app.occurrenceStart) continue;
    map.set(`${String(app.slotId)}:${occurrenceKey(app.occurrenceStart)}`, app);
  }
  return map;
};

const isSlotFilledForOccurrence = (slotId, occurrenceStart, acceptedMap) =>
  acceptedMap.has(`${String(slotId)}:${occurrenceKey(occurrenceStart)}`);

export const getSlotSummaryForOccurrence = (event, occurrenceStart) => {
  const slots = Array.isArray(event?.performerSlots) ? event.performerSlots : [];
  const slotCount = slots.length;

  if (slotCount === 0) {
    return {
      slotCount: 0,
      openSlotCount: 0,
      filledSlotCount: 0,
      hasSlots: false,
      slotSummaryLabel: "",
    };
  }

  if (occurrenceStart && Array.isArray(event?._slotApplications)) {
    const acceptedMap = buildAcceptedMap(event._slotApplications);
    const filledSlotCount = slots.filter((slot) =>
      isSlotFilledForOccurrence(slot._id, occurrenceStart, acceptedMap)
    ).length;
    const openSlotCount = slotCount - filledSlotCount;

    return {
      slotCount,
      openSlotCount,
      filledSlotCount,
      hasSlots: true,
      slotSummaryLabel: `${openSlotCount} open / ${slotCount} slot${slotCount === 1 ? "" : "s"}`,
    };
  }

  const filledSlotCount = slots.filter((slot) => slot.status === "filled").length;
  const openSlotCount = slotCount - filledSlotCount;

  return {
    slotCount,
    openSlotCount,
    filledSlotCount,
    hasSlots: true,
    slotSummaryLabel: `${openSlotCount} open / ${slotCount} slot${slotCount === 1 ? "" : "s"}`,
  };
};
